export const scheduleDialogHeader = "Pxc";
export const scheduleCancelButton = "Qxc";
export const returnToSuggestions = "Rxc";
export default {scheduleDialogHeader,scheduleCancelButton,returnToSuggestions};